angular.module('SpidApp')

.factory('RouteSupervisor',
[        '$state', '$timeout', 'User', 'Toaster',
function ($state,   $timeout,   User,   Toaster) {
	var RouteSupervisor = {
		check: function(event, activateRole) {
	        var params = $state.params.roles || [];
	        
	        if (params.length > 0 && params.lastIndexOf(activateRole) === -1) {
	            this.bounce(event, activateRole);
	        }
		},
		
		bounce: function(event, activateRole) {
			event.preventDefault();
			$timeout(function () {
            	$state.go('app');
            	Toaster.danger("Le <b>" + User.getDisplayName(activateRole) + "</b> ne peut pas accéder à cette page");
            }, 75)
		}
	}

	return RouteSupervisor
}])